<template>
  <div class="overlay-full overlay-incoming-call">
    <div class="overlay-content">
      <p class="title">Incoming Call</p>
      <div class="avatar">
        <img src="" id="incoming-call-img" alt="">
      </div>
      <p id="incoming-call-name"></p>
      <a href="uniphone://" class="btn btn-primary" id="incoming-call-close">Open UniPhone</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "OverlayIncomingCall"
}
</script>